/* Shared Essencraft quiz funnel state (Stage 1 → Stage 2). No PII. */
(function (w) {
  'use strict';
  var LS_KEY = 'ec_quiz_funnel_v3';
  var SS_KEY = 'ec_quiz_funnel_session_v3';

  function store(kind) {
    try {
      var s = w[kind];
      var t = '__ec_funnel__';
      s.setItem(t, '1');
      s.removeItem(t);
      return s;
    } catch (e) {
      return null;
    }
  }

  var ls = store('localStorage');
  var ss = store('sessionStorage');

  function read() {
    if (!ls) return null;
    try {
      return JSON.parse(ls.getItem(LS_KEY) || 'null');
    } catch (e) {
      return null;
    }
  }

  function write(partial) {
    if (!ls) return null;
    var cur = read() || {};
    var next = Object.assign({}, cur, partial || {}, { updated_at: new Date().toISOString() });
    try {
      ls.setItem(LS_KEY, JSON.stringify(next));
    } catch (e) {}
    return next;
  }

  function readSession() {
    if (!ss) return {};
    try {
      return JSON.parse(ss.getItem(SS_KEY) || '{}');
    } catch (e) {
      return {};
    }
  }

  function writeSession(partial) {
    if (!ss) return {};
    var cur = readSession();
    var next = Object.assign({}, cur, partial || {});
    try {
      ss.setItem(SS_KEY, JSON.stringify(next));
    } catch (e) {}
    return next;
  }

  function syncDom(state) {
    if (!state) return;
    var root = document.documentElement;
    root.setAttribute('data-ec-quiz-route', state.route || '');
    root.setAttribute('data-ec-quiz-concern', state.concern || '');
    root.setAttribute('data-ec-quiz-completed', state.quizCompleted ? 'true' : 'false');
    root.setAttribute('data-ec-quiz-product', state.commercialProduct || '');
  }

  w.ECQuizFunnel = {
    LS_KEY: LS_KEY,
    SS_KEY: SS_KEY,
    read: read,
    write: write,
    readSession: readSession,
    writeSession: writeSession,
    syncDom: syncDom
  };
})(window);
